import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { AddFundsForm } from './AddFundsForm'

function AddFundsPage() {
  return (
    <PageContainer className="flex flex-col items-center justify-center">
      <AddFundsForm />
    </PageContainer>
  )
}

export default AddFundsPage
